var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "format-parameters-editor" }, [
    _vm.showhint &&
    _vm.foundTags.filter(function(x) {
      return !_vm.parameters.find(function(y) {
        return y.tag === x
      })
    }).length > 0
      ? _c(
          "p",
          [
            _vm._v(
              "\n    The following parameters were detected in the sourcecode (click to add): "
            ),
            _c("br"),
            _vm._v(" "),
            _vm._l(
              _vm.foundTags.filter(function(x) {
                return !_vm.parameters.find(function(y) {
                  return y.tag === x
                })
              }),
              function(tag) {
                return _c(
                  "v-btn",
                  {
                    staticClass: "btn-format-parameter-add shorthand",
                    on: {
                      click: function(ev) {
                        return _vm.addParameterShorthand(ev, tag)
                      }
                    }
                  },
                  [_vm._v(_vm._s(tag))]
                )
              }
            )
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "p",
      [
        _vm.parameters.length > 0
          ? _c("v-simple-table", {
              staticClass: "parameters",
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v("\n              Parameter\n            ")
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v("\n              Type\n            ")
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v(
                                "\n              Description\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v(
                                "\n              Default value\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v(
                                "\n              Is replaceable\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("th")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.parameters, function(item, index) {
                            return _c(
                              "tr",
                              {
                                key: item.id,
                                class: {
                                  notFound:
                                    _vm.foundTags.find(function(x) {
                                      return x === item.tag
                                    }) === undefined
                                }
                              },
                              [
                                _c(
                                  "td",
                                  { staticClass: "parameter-tag" },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        placeholder: "Parameter",
                                        rules: [_vm.inputValidation.required]
                                      },
                                      model: {
                                        value: item.tag,
                                        callback: function($$v) {
                                          _vm.$set(item, "tag", $$v)
                                        },
                                        expression: "item.tag"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "parameter-type" },
                                  [
                                    _c("format-parameter-type-selector", {
                                      attrs: {
                                        rules: [_vm.inputValidation.required]
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.formatParameterTypeChanged(
                                            item
                                          )
                                        }
                                      },
                                      model: {
                                        value: item.formatParameterType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "formatParameterType",
                                            $$v
                                          )
                                        },
                                        expression: "item.formatParameterType"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "parameter-description" },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        placeholder: "Description",
                                        rules: [_vm.inputValidation.required]
                                      },
                                      model: {
                                        value: item.description,
                                        callback: function($$v) {
                                          _vm.$set(item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "parameter-defaultValue" },
                                  [
                                    item.formatParameterType === "Text"
                                      ? _c("format-parameters-text", {
                                          attrs: { formatParameter: item },
                                          model: {
                                            value: _vm.parameters[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "parameters[index]"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.formatParameterType === "Image"
                                      ? _c("format-parameters-image", {
                                          attrs: {
                                            formatParameter: item,
                                            previewPath: _vm.assetsPath
                                          },
                                          model: {
                                            value: _vm.parameters[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "parameters[index]"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.formatParameterType === "Video"
                                      ? _c("format-parameters-video", {
                                          attrs: {
                                            formatParameter: item,
                                            previewPath: _vm.assetsPath
                                          },
                                          model: {
                                            value: _vm.parameters[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "parameters[index]"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.formatParameterType ===
                                    "SeenThisStream"
                                      ? _c("format-parameters-seenthis", {
                                          attrs: { formatParameter: item },
                                          model: {
                                            value: _vm.parameters[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "parameters[index]"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.formatParameterType === "Choice"
                                      ? _c("format-parameters-choice", {
                                          attrs: { formatParameter: item },
                                          model: {
                                            value: _vm.parameters[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "parameters[index]"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.formatParameterType === "FeedKey"
                                      ? _c("format-parameters-feed-key", {
                                          attrs: { formatParameter: item },
                                          model: {
                                            value: _vm.parameters[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "parameters[index]"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.formatParameterType === "InsTag"
                                      ? _c("format-parameters-textarea", {
                                          attrs: { formatParameter: item },
                                          model: {
                                            value: _vm.parameters[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.parameters,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "parameters[index]"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "parameter-isReplaceableValue"
                                  },
                                  [
                                    _c("v-checkbox", {
                                      model: {
                                        value: item.isReplaceableValue,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "isReplaceableValue",
                                            $$v
                                          )
                                        },
                                        expression: "item.isReplaceableValue"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "parameter-actions" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "error" },
                                        on: {
                                          click: function(ev) {
                                            return _vm.removeParameter(item)
                                          }
                                        }
                                      },
                                      [_vm._v("X")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                392818984
              )
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      [
        _c(
          "v-btn",
          { attrs: { color: "success" }, on: { click: _vm.addParameter } },
          [_vm._v("Add new parameter")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }